import { render, staticRenderFns } from "./IntegrationExclusionSettings.vue?vue&type=template&id=2a1cf0e1&scoped=true"
import script from "./IntegrationExclusionSettings.vue?vue&type=script&lang=js"
export * from "./IntegrationExclusionSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1cf0e1",
  null
  
)

export default component.exports